<template>
    <div>
        <div v-if="inTable">
            <div v-if="fileList.length" :class="{ 'file-preview-container': limit > 1 }">
                <div v-for="file in fileList" :key="file.url" class="file-preview-item">
                    <div v-if="isImage(file.name)" class="file-preview-content">
                        <img :src="file.url" class="file-preview-image" />
                    </div>
                    <div v-else class="file-preview-content">
                        <i class="el-icon-document file-icon"></i>
                        <span class="file-name">{{ file.name }}</span>
                    </div>
                    <div class="file-preview-actions">
                        <i v-if="isImage(file.name)" @click="handlePreview(file)" class="el-icon-view">预览</i>
                        <i v-else @click="downloadFile(file.url)" class="el-icon-download">下载</i>
                        <i v-show="showPlusAndDel" @click="handleRemove(file)" class="el-icon-delete">删除</i>
                    </div>
                </div>
            </div>
            <el-upload ref="upload" :action="action" :multiple="multiple" :limit="limit" :on-exceed="handleExceed"
                :on-preview="handlePreview" :file-list="fileList" :http-request="fnUploadRequest" :accept="accept"
                :show-file-list="false" :on-remove="handleRemove" class="custom-upload">
                <i class="el-icon-plus" v-show="showPlusAndDel">
                    <div slot="tip" class="el-upload__tip">限制{{ limit }}个文件</div>
                </i>
            </el-upload>
        </div>
        <!-- 非表格模式 -->
        <div v-else>
            <el-upload v-if="fileList.length < limit" ref="upload" :action="action" :multiple="multiple" :limit="limit"
                :on-exceed="handleExceed" :on-preview="handlePreview" :file-list="fileList"
                :http-request="fnUploadRequest" :list-type="listTypeMode" :accept="accept"
                :show-file-list="showFileList" :on-remove="handleRemove">
                <i class="el-icon-plus" v-show="showPlusAndDel">
                    <div slot="tip" class="el-upload__tip">限制{{ limit }}个文件</div>
                </i>
            </el-upload>
            <div v-else class="file-preview-container" style="display: block;unicode-bidi: isolate;">
                <div v-for="file in fileList" :key="file.url" class="file-preview-item">
                    <div v-if="isImage(file.name)" class="file-preview-content">
                        <img :src="file.url" class="file-preview-image" />
                    </div>
                    <div v-else class="file-preview-content">
                        <i class="el-icon-document file-icon"></i>
                        <span class="file-name">{{ file.name }}</span>
                    </div>
                    <div class="file-preview-actions">
                        <i v-if="isImage(file.name)" @click="handlePreview(file)" class="el-icon-view">预览</i>
                        <i v-else @click="downloadFile(file.url)" class="el-icon-download">下载</i>
                        <i v-show="showPlusAndDel" @click="handleRemove(file)" class="el-icon-delete">删除</i>
                    </div>
                </div>
            </div>
        </div>
        <!-- 图片预览对话框 -->
        <el-dialog width="60%" append-to-body :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
    name: "ImageUpload",
    props: {
        inTable: {
            type: Boolean,
            default: false,
        },
        showPlusAndDel: {
            type: Boolean,
            default: true,
        },
        action: {
            type: String,
            default: '#',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        limit: {
            type: Number,
            default: 1,
        },
        showFileList: {
            type: Boolean,
            default: true,
        },
        uploadedImages: {
            type: [Array, String],
            default: () => [],
        },
        listTypeMode: {
            type: String,
            default: 'picture',
        },
        accept: {
            type: String,
            default: 'image/*,application/pdf,application/msword,application/vnd.ms-excel,.txt',
        },
    },
    data() {
        return {
            fileList: [],
            dialogImageUrl: "",
            dialogVisible: false,
            localUploadedImages: [] // 本地上传的图片列表
        };
    },
    watch: {
        uploadedImages: {
            immediate: true,
            handler() {
                this.initializeFileList();
            }
        }
    },
    mounted() {
        this.initializeFileList();
    },
    created() {
        this.initializeFileList();
    },
    methods: {
        isImage(url) {
            return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
        },
        downloadFile(fileUrl) {
            // 打开文件 URL 在新窗口中
            window.open(fileUrl, '_blank');
        },
        initializeFileList() {
            let images = [];
            if (typeof this.uploadedImages === 'string' && this.uploadedImages.length > 0) {
                images = this.uploadedImages.split(',').map(url => url.trim()).filter(url => url);
            } else if (Array.isArray(this.uploadedImages)) {
                images = this.uploadedImages.map(image => typeof image === 'object' ? image.url : image);
            }

            this.fileList = images.map(url => ({
                name: url.split('/').pop(),
                url: url,
            }));

            this.localUploadedImages = [...this.fileList]; // Save the list to local state
        },
        handleRemove(file) {
            this.fileList = this.fileList.filter(item => item.url !== file.url);
            this.localUploadedImages = this.fileList; // 删除后更新本地上传图片列表
            this.$emit('uploaded', this.fileList);
        },
        handleExceed() {
            this.$message.warning(`当前限制选择 ${this.limit} 个文件`);
        },
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        async fnUploadRequest(option) {
            try {
                const res = await getAliyunPublicToken();
                const data = JSON.parse(res.data);
                const client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                const storeAs = md5(option.file.name) + new Date().getTime()+option.file.name;
                const results = await client.multipartUpload(storeAs, option.file, {});
                const url = results.res.requestUrls[0].split("?")[0];

                // 使用onSuccess返回的数据
                option.onSuccess({ url }, option.file);

                // 直接更新fileList
                this.fileList.push({ name: option.file.name, url });
                console.log('this.fileList::: ', this.fileList);
                this.$emit('uploaded', this.fileList);

                // 由于已经更新了fileList，所以这里不需要调用initializeFileList
            } catch (err) {
                option.onError(err);
                this.$message.error('文件上传失败，请重试！'); // 添加用户友好的错误提示
            }
        }
    },
};
</script>

<style scoped>
.custom-upload .el-upload__input {
    display: none;
}

.file-preview-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.file-preview-item {
    position: relative;
    display: inline-block;
    margin: 10px;
    width: 80px;
    height: 80px;
}

.file-preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
}

.file-preview-item:hover .file-preview-image {
    opacity: 0.3;
}

.file-preview-actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    gap: 5px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.file-preview-item:hover .file-preview-actions {
    opacity: 1;
}

.file-preview-actions .el-icon-view,
.file-preview-actions .el-icon-delete {
    cursor: pointer;
    font-size: 16px;
    color: #e6a23c;
}

.file-icon {
    font-size: 40px;
    color: #909399;
}

.file-name {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
